import React, { FC, memo, useState } from 'react';
import { Modal } from 'antd';
import { LeftOutlined, CheckOutlined } from '@ant-design/icons';
import * as styles from './QuizModal.module.css';
import { Button } from 'src/components/Button/Button.tsx';

import maleIcon from 'url:../../../assets/images/gender-male.webp';
import femaleIcon from 'url:../../../assets/images/gender-female.webp';
import otherIcon from 'url:../../../assets/images/gender-other.webp';
import bannerBgMobileMain from 'url:../../../assets/images/banner-bg-mobile-main.webp';

interface QuizModalProps {
  visible: boolean;
  onClose: () => void;
}

const iconMap = {
  male: maleIcon,
  female: femaleIcon,
  other: otherIcon,
} as const;

const QuizModal: FC<QuizModalProps> = ({ visible, onClose }) => {
  const [selection, setSelection] = useState<'female' | 'male' | 'other' | undefined>(undefined);

  const handleNext = () => {
    console.log('Gender selected:', selection);
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={null}
      className={styles.quizModalContainer}
      width={600}
      centered
      maskClosable={false}
      styles={{
        wrapper: {
          backgroundColor: '#fef5e7',
          backgroundImage: `url(${bannerBgMobileMain})`,
          backgroundRepeat: `no-repeat`,
          backgroundPosition: `top left`,
          backgroundSize: `100% auto`,
        },
      }}
    >
      <div>
        {/* HEADER */}
        <div className={styles.headerLayer}>
          <button className={styles.backButton} onClick={onClose}>
            <LeftOutlined />
          </button>
          <div className={styles.progressCounter}>1/12</div>
        </div>

        <div className={styles.headerProgress}>
          <div style={{ width: '8%' }} className={styles.progressBar} />
        </div>

        {/* CONTENT */}
        <div className={styles.quizModalContent}>
          <div className={styles.title}>
            First things first:
            <br />
            Let’s get to know you!
          </div>

          <div className={styles.question}>What is your gender?</div>

          <div className={styles.optionsColumn}>
            {(['female', 'male', 'other'] as const).map((key) => (
              <label
                key={key}
                className={`${styles.optionRow} ${selection === key ? styles.selected : ''}`}
                onClick={() => setSelection(key)}
              >
                <div className={styles.optionIcon}>
                  <img src={iconMap[key]} alt={key} className={styles.optionIconImage} />
                </div>

                <div className={styles.optionText}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </div>

                {selection === key && (
                  <div className={styles.checkMark}>
                    <CheckOutlined />
                  </div>
                )}
              </label>
            ))}
          </div>

          <Button disabled={!selection} onClick={handleNext} className={styles.nextButton}>
            Next
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default memo(QuizModal);
